module.exports = __webpack_public_path__ + "5018b8c04ec189526f0fe8890c7b7953.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/jean-yves-perrier.jpg
// module id = 640
// module chunks = 0